import './styles.scss';

import { GroupTypes } from '@/common/Group/types';
import { InputGroup } from 'react-bootstrap';
import { forwardRef } from 'react';
import { getClasses } from '@/utils';

const Group = forwardRef<HTMLDivElement, GroupTypes.Props>((props, ref) => (
  <InputGroup {...props} role="group" className={getClasses('Group', 'Common', props.className)} ref={ref} />
)) as GroupTypes.Component;
Group.displayName = 'Group';

Group.Text = InputGroup.Text;
export default Group;
